import { ApiProject } from "@incendium/api";
import { listAISessions } from "features/ai/services/aiService";
import { useProjectSharedState } from "Hooks/useSharedState";

export const useAISessions = () => {
  const fetch = async (project: ApiProject) => {
    const res = await listAISessions(project.id as number);
    return res.sessions || [];
  };

  const { state, setState, loading, fetched } = useProjectSharedState(
    "aiSessions",
    [],
    fetch
  );

  return {
    aiSessions: state,
    setAiSessions: setState,
    loading,
    fetched,
  };
};
